/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { drawerCloseWidth, drawerWidth } from '../NavBar/NavBar';
import IconButton from '@mui/material/IconButton';
import { SwitchLocalesSelect } from '../SwitchLocalesSelect/SwitchLocalesSelect';
import MenuIcon from '@mui/icons-material/Menu';
import { theme } from '../../assets/style/them';
import { AccountMenu } from './AccountMenu';
import DelayedDownloadings from '../DelayedDownloadings/DelayedDownloadings';

export const TOP_BAR_HEIGHT = 64;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        appBar: {
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            width: `calc(100% - ${drawerCloseWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        appBarShift: {
            boxShadow: 'none',
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        toolBar: {
            [theme.breakpoints.down('md')]: {
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                padding: theme.spacing(0, 2),
            },
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(1, 1, 0, 1),
            },
        },
        toolBarRightContent: {
            display: 'flex',
        },
        menuIcon: {
            color: theme.palette.text.primary,
        },
    }),
);

interface AppBarProps {
    isOpenNav: boolean;
    isMatchesSM: boolean;
    isMatchesXS: boolean;

    navBarToggle(): void;

    isTransparent?: boolean;
    hideDownloadings?: boolean;
}

export const TopBar = (props: AppBarProps) => {
    const { isOpenNav, navBarToggle, isMatchesSM, isTransparent, hideDownloadings } = props;
    const classes = useStyles();

    return (
        <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
                [classes.appBarShift]: isOpenNav,
            })}
            style={{
                background: isTransparent ? 'rgba(229, 229, 229, .6)' : theme.palette.mainBackground.main,
            }}
        >
            <Toolbar className={classes.toolBar}>
                {isMatchesSM && !isOpenNav ? (
                    <IconButton onClick={navBarToggle} size="large">
                        <MenuIcon className={classes.menuIcon} />
                    </IconButton>
                ) : (
                    <div />
                )}

                <div className={classes.toolBarRightContent}>
                    <AccountMenu isMatchesXS={props.isMatchesXS} />
                    {!hideDownloadings && <DelayedDownloadings />}
                    <SwitchLocalesSelect />
                </div>
            </Toolbar>
        </AppBar>
    );
};
